import Vue from 'vue'
import Vuex from 'vuex'

import { increasedMessagePushUnread } from '@/api/increased.js'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    id: '',
    phone: '', // 手机号
    nickName: '', // 昵称
    unitName: '', // 单位名称
    toEmail: '', // 邮箱
    count: 0 // 未读消息数量
  },
  mutations: {
    // setId(state, val) {
    //   state.id = val
    // },
    // 统一设置用户信息。
    // 其他页面设置方式：
    // this.$store.commit('setUserInfo', {
    //   phone: res.result.loginName,
    //   nickName: res.result.nickName,
    //   unitName: res.result.unitName,
    //   toEmail: res.result.toEmail
    // })
    // 其他页面读取方式：this.$store.state.phone、this.$store.state.nickName、
    // this.$store.state.unitName、this.$store.state.toEmail
    setUserInfo(state, userInfo = {}) {
      state.id = userInfo.id || ''
      state.phone = userInfo.phone || ''
      state.nickName = userInfo.nickName || ''
      state.unitName = userInfo.unitName || ''
      state.toEmail = userInfo.toEmail || ''
    },
    // 保留原方法，兼容项目中已有的手机号单独设置逻辑
    // setPhone(state, val) {
    //   state.phone = val
    // },
    saveCount(state, val) {
      state.count = val
    }
  },
  actions: {
    updateCount(context) {
      increasedMessagePushUnread().then(res => {
        if (res.code == '000') {
          const count = res.result.id
          context.commit('saveCount', count)
        }
      })
    }
  },
  modules: {
  }
})
